import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { AuthGuard } from "./shared/guards/auth/auth.guard";
import { RoleGuard } from "./shared/guards/role/role.guard";
import { TestComponent } from "./test/test.component";
import { ProfileSettingsComponent } from "./profile-settings/profile-settings.component";
import { NewDashboardComponent } from "./new-dashboard/new-dashboard.component";
import { NewSettingsComponent } from "./new-settings/new-settings.component";
import { SetupComponent } from "./setup/setup.component";

const routes: Routes = [
	{
		path: "",
		redirectTo: "/dashboard",
		pathMatch: "full",
		data: { breadcrumb: "Dashboard" },
	},
	{
		path: "dashboard",
		component: DashboardComponent,
		data: { breadcrumb: { skip: true } },
		canActivate: [AuthGuard],
	},
	{
		path: "new-dashboard",
		component: NewDashboardComponent,
		data: { breadcrumb: { skip: true } },
		canActivate: [AuthGuard],
	},
	{
		path: "properties",
		loadChildren: () => import("./properties/properties.module").then((m) => m.PropertiesModule),
		canActivate: [AuthGuard],
	},
	{
		path: "organization",
		loadChildren: () => import("./organization/organization.module").then((m) => m.OrganizationModule),
		canActivate: [AuthGuard],
		// data: { roles: ["admin"] },
	},
	{
		path: "automations",
		loadChildren: () => import("./automations/automations.module").then((m) => m.AutomationsModule),
		canActivate: [AuthGuard],
	},
	{
		path: "profile",
		component: ProfileSettingsComponent,
		canActivate: [AuthGuard],
	},
	{
		path: "locations",
		loadChildren: () => import("./locations/locations.module").then((m) => m.LocationsModule),
		canActivate: [AuthGuard],
	},
	{
		path: "users",
		loadChildren: () => import("./users/users.module").then((m) => m.UsersModule),
		canActivate: [AuthGuard],
		// data: { roles: ["admin", "installer"] },
	},
	{
		path: "settings",
		component: NewSettingsComponent,
	},
	{
		path: "test",
		component: TestComponent,
	},
	{
		path: "reports",
		loadChildren: () => import("./reports/reports.module").then((m) => m.ReportsModule),
	},
	{
		path: "**",
		component: PageNotFoundComponent,
		data: { breadcrumb: "Page not found" },
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
